module.exports = __webpack_public_path__ + "img/9.afde6cb3.jpeg";